import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  changeLoadingState,
  dispatch,
  addClientsState,
  clientLoginState,
  clientLogoutState,
  clientProfile,
  clientReport,
  clientsummary,
  setErrorMessage,
  setSuccessMessage,
} from "../redux";

export const addClient = async (clientdata) => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));
    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.clientRegister, {
      ...clientdata,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addClientsState(resp.data.results));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const clientLoginService = async (email, password) => {
  try {
    dispatch(changeLoadingState(true));
    const resp = await httpClient().patch(ApiEndpoints.clientLogin, {
      email,
      password,
    });

    if (!resp.data.success && resp.status >= 201) {
      throw new Error(resp.data.message);
    }

    dispatch(clientLoginState(resp.data.result.token));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(changeLoadingState(false));
    dispatch(setErrorMessage(error.message));
  }
};

export const forgetClientPasswordService = async (email) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.forgetClientPassword, {
      email,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const logoutClient = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // Update to Store
    dispatch(clientLogoutState());
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const getClientProfile = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.clientProfile);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(clientProfile(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const getClientReport = async (year) => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.fitnessReport, {
      params: {
        year: year,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(clientReport(resp.data.results));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const getClientSummary = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.clientsummary);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(clientsummary(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const changeClientProfileService = async (formData) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.changeClientProfile, {
      ...formData,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(clientProfile(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
export const changeClientPasswordService = async (
  // token,
  currentPassword,
  newPassword
) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.changeClientPassword, {
      // token,
      currentPassword,
      newPassword,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
export const changeClientEmailService = async (
  // token,
  // currentEmail,
  newEmail
) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.changeClientEmail, {
      email: newEmail,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
export const resetClientPasswordService = async (token, password) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.resetClientPasswords, {
      token,
      password,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const getClientReportPdf = async (clientId) => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(
      ApiEndpoints.clientdownloadreport + "/" + clientId
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
